module.exports = __webpack_public_path__ + "assets/img/73.ce112cc8.png";